/**
 * 🌐 USE LANGUAGE HOOK
 * =====================
 * Hook reativo para mudanças de idioma
 * Garante que o componente re-renderiza quando o idioma muda
 * 
 * Idiomas suportados: pt, pt-BR, es, en
 * DEFAULT: Português (pt)
 * 
 * Uso:
 * const lang = useLanguage(); // 'pt', 'es' ou 'en'
 */

import { useState, useEffect } from 'react';
import i18n from '@/i18n';

export function useLanguage() {
  // Normaliza o idioma para os códigos principais
  const normalizeLanguage = (lng) => {
    if (!lng) return 'pt'; // DEFAULT: Português
    if (lng.startsWith('pt')) return 'pt'; // pt, pt-BR → pt
    if (lng === 'es') return 'es';          // es → es
    if (lng === 'en') return 'en';          // en → en
    return 'pt'; // fallback: SEMPRE Português
  };

  // Obtém idioma do localStorage OU do i18n, COM FALLBACK para PT
  const getInitialLang = () => {
    const savedLang = localStorage.getItem('language');
    if (savedLang && ['pt', 'pt-BR', 'en', 'es'].includes(savedLang)) {
      return normalizeLanguage(savedLang);
    }
    return normalizeLanguage(i18n.language);
  };

  const [lang, setLang] = useState(getInitialLang);
  
  useEffect(() => {
    const handleLanguageChange = (newLang) => {
      const normalizedLang = normalizeLanguage(newLang);
      setLang(normalizedLang);
    };
    
    // Set initial value from localStorage or i18n
    setLang(getInitialLang());
    
    // Listen for changes
    i18n.on('languageChanged', handleLanguageChange);
    
    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, []);
  
  return lang;
}

export default useLanguage;
